import { useCallback, useEffect, useRef, useState } from "react";
import API from "../../Network/API";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-hot-toast";
import Select from "react-select";
import { JOB_FETCH_MORE_SUCCESS, JOB_FETCH_SUCCESS, JOB_INACTIVE_SUCCESS } from "../../Reducer/JobSlice";
import JobDetails from "./JobDetails";
import JobCreate from "./JobCreate";
import JobEdit from "./JobEdit";

const STATUS_OPTIONS = [
    { value: "1", label: "Active" },
    { value: "0", label: "Inactive" },
];

export default function JobIndex() {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(true);
    const [jobId, setjobId] = useState(0);
    const [searchType, setSearchType] = useState(1);
    const [searchText, setSearchText] = useState("");

    const [modalDialog, setModalDialog] = useState(false);
    const [show, setModalShow] = useState(false);
    const [showEdit, setModalShowEdit] = useState(false);
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(false);

    const [orgOptions, setOrgOptions] = useState([]);
    const [userOptions, setUserOptions] = useState([]);
    const [filterOrg, setFilterOrg] = useState(null);
    const [filterUser, setFilterUser] = useState(null);
    const [filterStatus, setFilterStatus] = useState(null);
    const [filterOpen, setFilterOpen] = useState(false);
    const filterRef = useRef(null);

    const filtersRef = useRef({ q: "", search_type: 1, organization_id: "", user_id: "", status: "" });

    const buildUrl = (pg, overrides = {}) => {
        const f = { ...filtersRef.current, ...overrides };
        const params = new URLSearchParams();
        params.set("page", pg);
        if (f.q) { params.set("q", f.q); params.set("search_type", f.search_type); }
        if (f.organization_id) params.set("organization_id", f.organization_id);
        if (f.user_id) params.set("user_id", f.user_id);
        if (f.status !== "" && f.status != null) params.set("status", f.status);
        return `/v1/oauth/jobs?${params.toString()}`;
    };

    const fetchJobs = (pg = 1, append = false) => {
        setLoading(true);
        API.get(buildUrl(pg)).then((response) => {
            const payload = response.data?.data ?? {};
            setHasMore(!!payload.has_more_page);
            dispatch(append ? JOB_FETCH_MORE_SUCCESS(payload) : JOB_FETCH_SUCCESS(payload));
            setLoading(false);
        }).catch(() => setLoading(false));
    };

    useEffect(() => {
        fetchJobs(1, false);
        API.get("/v1/oauth/jobs/create").then((res) => {
            setOrgOptions(res.data?.data?.organizations ?? []);
        }).catch(() => {});
    }, []);

    useEffect(() => {
        if (page !== 1) fetchJobs(page, true);
    }, [page]);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (filterRef.current && !filterRef.current.contains(e.target)) {
                setFilterOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const observer = useRef();
    const lastElementRef = useCallback((element) => {
        if (observer.current) observer.current.disconnect();
        if (!hasMore) return;
        observer.current = new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting && hasMore) setPage((prev) => prev + 1);
        });
        if (element) observer.current.observe(element);
    }, [hasMore]);

    const toggleModal = (jid) => { setjobId(jid); setModalDialog(!modalDialog); };
    const toggleModalEdit = (jid) => { setjobId(jid); setModalShowEdit(!showEdit); };

    const searchSite = (value) => {
        setSearchText(value);
        filtersRef.current.q = value;
        filtersRef.current.search_type = searchType;
        setPage(1);
        fetchJobs(1, false);
    };

    const handleOrgChange = (e) => {
        setFilterOrg(e);
        setFilterUser(null);
        setUserOptions([]);
        if (!e) return;
        API.get(`/v1/oauth/ajax_vendor_users/${e.value}`).then((res) => {
            setUserOptions(res.data?.data?.users ?? []);
        }).catch(() => {});
    };

    const applyFilters = () => {
        filtersRef.current.organization_id = filterOrg?.value ?? "";
        filtersRef.current.user_id = filterUser?.value ?? "";
        filtersRef.current.status = filterStatus?.value ?? "";
        setPage(1);
        fetchJobs(1, false);
        setFilterOpen(false);
    };

    const resetFilters = () => {
        setFilterOrg(null);
        setFilterUser(null);
        setFilterStatus(null);
        setUserOptions([]);
        filtersRef.current.organization_id = "";
        filtersRef.current.user_id = "";
        filtersRef.current.status = "";
        setPage(1);
        fetchJobs(1, false);
    };

    const inactiveJob = (id) => {
        if (!window.confirm("Are you sure you want to inactive this job?")) return;
        API.post(`/v1/oauth/jobs/${id}/inactive`)
            .then((response) => {
                toast.success(response.data?.message ?? "Job inactivated");
                dispatch(JOB_INACTIVE_SUCCESS(response.data.data));
            })
            .catch((error) => {
                toast.error(error.response?.data?.message ?? "Failed to inactive job");
            });
    };

    const syncData = () => {
        setPage(1);
        fetchJobs(1, false);
    };

    const activeFilterCount = [filterOrg, filterUser, filterStatus].filter(Boolean).length;
    const selector = useSelector((state) => state.jobReducer);

    return (
        <>
            <div className="row mb-2 me-1 ms-1">
                <div className="align-items-center d-flex mt-2">
                    <h6 className="main-card-title mb-0 flex-grow-1"> </h6>
                    <div className="flex-shrink-0">
                        <div className="input-group input-group-sm">
                            <select className="form-select" value={searchType} onChange={(e) => setSearchType(e.target.value)}>
                                <option value={1}>Site ID</option>
                                <option value={2}>Card Number</option>
                                <option value={3}>Phone Number</option>
                            </select>
                            <input
                                onChange={(e) => searchSite(e.target.value)}
                                value={searchText}
                                type="text"
                                className="form-control"
                                placeholder="search............."
                            />
                            <button className="btn btn-success" type="button"><i className="fa-light fa-search me-1" />Search</button>

                          
                                <button
                                    className={`btn ${activeFilterCount > 0 ? "btn-info" : "btn-outline-info"}`}
                                    type="button"
                                    onClick={() => setFilterOpen((v) => !v)}
                                >
                                    <i className="fa-light fa-filter me-1" />Filter
                                    {activeFilterCount > 0 && (
                                        <span className="badge bg-light text-dark ms-1">{activeFilterCount}</span>
                                    )}
                                </button>
  <div className="position-relative" ref={filterRef}>
                                {filterOpen && (
                                    <div
                                        className="card shadow border position-absolute end-0 mt-1 p-3"
                                        style={{ width: 320, zIndex: 1050 }}
                                    >
                                        <div className="mb-2">
                                            <label className="form-label small mb-1">Organization</label>
                                            <Select
                                                isClearable
                                                value={filterOrg}
                                                onChange={handleOrgChange}
                                                options={orgOptions}
                                                placeholder="Select organization"
                                                menuPortalTarget={document.body}
                                                styles={{ menuPortal: (b) => ({ ...b, zIndex: 9999 }) }}
                                            />
                                        </div>
                                        <div className="mb-2">
                                            <label className="form-label small mb-1">User</label>
                                            <Select
                                                isClearable
                                                isDisabled={!filterOrg}
                                                value={filterUser}
                                                onChange={setFilterUser}
                                                options={userOptions}
                                                placeholder={filterOrg ? "Select user" : "Select organization first"}
                                                menuPortalTarget={document.body}
                                                styles={{ menuPortal: (b) => ({ ...b, zIndex: 9999 }) }}
                                            />
                                        </div>
                                        <div className="mb-3">
                                            <label className="form-label small mb-1">Status</label>
                                            <Select
                                                isClearable
                                                value={filterStatus}
                                                onChange={setFilterStatus}
                                                options={STATUS_OPTIONS}
                                                placeholder="Select status"
                                                menuPortalTarget={document.body}
                                                styles={{ menuPortal: (b) => ({ ...b, zIndex: 9999 }) }}
                                            />
                                        </div>
                                        <div className="d-flex justify-content-end gap-2">
                                            <button type="button" className="btn btn-sm btn-outline-secondary" onClick={resetFilters}>
                                                Reset
                                            </button>
                                            <button type="button" className="btn btn-sm btn-success" onClick={applyFilters}>
                                                Apply
                                            </button>
                                        </div>
                                    </div>
                                )}
                            </div>

                            <button className="btn btn-success" type="button" onClick={() => setModalShow(true)}>
                                <i className="fa-light fa-plus me-1" />Add Job
                            </button>
                            <button className="btn btn-warning" type="button" onClick={() => syncData()}>
                                <i className="fa-light fa-refresh me-1" />Sync
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row mb-2 mt-2 me-1 ms-1">
                <div className="col-xl-12 col-lg-12">
                    <div className="table-responsive bg-white pe-1 ps-1 pt-1">
                        <table className="table table-bordered table-striped text-center">
                            <thead className="text-uppercase">
                                <tr>
                                    <th scope="col" className="text-center toi-primary">SL</th>
                                    <th scope="col" width="25%" className="text-center toi-primary">Job Name</th>
                                    <th scope="col" className="text-center toi-primary">Assign For</th>
                                    <th scope="col" className="text-center toi-primary">Organization</th>
                                    <th scope="col" className="text-center toi-primary">Start Time</th>
                                    <th scope="col" className="text-center toi-primary">End Time</th>
                                    <th scope="col" className="text-center toi-primary">Status</th>
                                    <th scope="col" className="text-center toi-primary" width="15%">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {!selector?.loading && (selector?.main_data ?? []).map((row, index, rows) => (
                                    <tr className="fs-11" key={row.id ?? index} ref={index === rows.length - 1 ? lastElementRef : undefined}>
                                        <td>{index + 1}</td>
                                        <td>{row.subject}</td>
                                        <td>{row.user_name}</td>
                                        <td>{row.organization_name}</td>
                                        <td>
                                            <p className="m-0 p-0">{row.start_date_txt}</p>
                                            <p className="m-0 p-0">{row.start_time_txt}</p>
                                        </td>
                                        <td>
                                            <p className="m-0 p-0">{row.end_date_txt}</p>
                                            <p className="m-0 p-0">{row.end_time_txt}</p>
                                        </td>
                                        <td>
                                            <span className={`badge ${row.status == 1 ? 'bg-success' : 'bg-danger'}`}>{row.status_name}</span>
                                        </td>
                                        <td className="text-nowrap">
                                            <div className="d-inline-flex align-items-stretch job-action-cell">
                                                <button onClick={() => toggleModal(row.id)} type="button" className="btn btn-sm btn-secondary waves-effect rounded-end-0">
                                                    <i className="fa fa-list mr-1" /> <span>Details</span>
                                                </button>
                                                <div className="dropdown">
                                                    <button
                                                        type="button"
                                                        className="btn btn-sm btn-info dropdown-toggle dropdown-toggle-split waves-effect rounded-start-0"
                                                        data-bs-toggle="dropdown"
                                                        data-bs-popper-config='{"strategy":"fixed"}'
                                                        aria-expanded="false"
                                                    >
                                                        <i className="fe-more-vertical font-18 align-middle" />
                                                    </button>
                                                    <ul className="dropdown-menu dropdown-menu-end">
                                                        <li>
                                                            <button type="button" className="dropdown-item" onClick={() => toggleModalEdit(row.id)}>
                                                                <i className="fa-solid fa-edit mr-1" /> Edit
                                                            </button>
                                                        </li>
                                                        <li>
                                                            <button type="button" className="dropdown-item" onClick={() => inactiveJob(row.id)}>
                                                                <i className="fa-solid fa-diameter-variant mr-1" /> Inactive
                                                            </button>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        {loading && <div className="text-center">Loading......</div>}
                    </div>
                </div>
            </div>

            <JobDetails job_id={jobId} isModalVisible={modalDialog} handleShowB={() => setModalDialog(false)} />
            <JobCreate isModalVisible={show} handleShowB={() => setModalShow(false)} />
            <JobEdit job_id={jobId} isModalVisible={showEdit} handleShowB={() => setModalShowEdit(false)} />
        </>
    );
}
